import * as localforage from "localforage";
import { phpRequest } from "./phpRequest";

export const getCompanyGroupsAPI = async (selectedCompanyId) => {
  const companyId = !selectedCompanyId
    ? await localforage.getItem("userCompanyID")
    : selectedCompanyId;

  const data = await phpRequest.get("/company/groups", {
    company_id: companyId,
  });
  return data.data;
};
